import { PayloadAction, createSlice } from '@reduxjs/toolkit'

interface IHistoricoCambioReservaCentralizadaUiState {
  codigoReserva: string
  activeCodigoReserva: string
}

const initialState: IHistoricoCambioReservaCentralizadaUiState = {
  codigoReserva: '',
  activeCodigoReserva: '',
}

const historicoCambioReservaCentralizadaSlice = createSlice({
  name: 'historicoCambioReservaCentralizadaUi',
  initialState,
  reducers: {
    setFiltro: (state, action: PayloadAction<string>) => {
      state.codigoReserva = action.payload
    },
    cargarData: (state) => {
      state.activeCodigoReserva = state.codigoReserva
    },
    resetFiltro: (state) => {
      state.codigoReserva = ''
      state.activeCodigoReserva = ''
    },
  },
})

export const { setFiltro, cargarData, resetFiltro } = historicoCambioReservaCentralizadaSlice.actions

export default historicoCambioReservaCentralizadaSlice.reducer
